var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "viewer", rawName: "v-viewer" }],
      staticClass: "upload-viewer",
      style: _vm.isUseObs ? "min-height: 60px" : ""
    },
    [
      _vm.isUseObs
        ? _vm._l(_vm.defaultList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                attrs: {
                  draggable: _vm.max !== _vm.PICTURE_NUM && _vm.draggable
                },
                on: {
                  dragstart: function($event) {
                    return _vm.handleDragStart($event, index)
                  },
                  dragenter: function($event) {
                    $event.preventDefault()
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                  },
                  drop: function($event) {
                    return _vm.handleDragEnd($event, index)
                  }
                }
              },
              [
                !item.status || item.status === "success"
                  ? [
                      _c("div", { staticClass: "upload-viewer__pic" }, [
                        _vm.uploadType === "image"
                          ? _c("img", {
                              staticClass: "upload-viewer__pic--img",
                              attrs: { src: item.url }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uploadType === "video"
                          ? _c("video", {
                              staticClass: "upload-viewer__pic--img",
                              attrs: { src: item.url }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uploadType === "video"
                          ? _c("i", {
                              staticClass:
                                "el-icon-video-play upload-viewer__pic--play",
                              on: {
                                click: function($event) {
                                  return _vm.handlePlayVideo(item, index)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$attrs.disabled
                          ? _c("i", {
                              staticClass:
                                "el-icon-circle-close upload-viewer__pic--icon",
                              on: {
                                click: function($event) {
                                  return _vm.handleDel(item, index)
                                }
                              }
                            })
                          : _vm._e()
                      ])
                    ]
                  : item.percentage && item.percentage !== 100
                  ? [
                      _c("div", { staticClass: "upload-viewer__pic" }, [
                        _c(
                          "div",
                          { staticClass: "upload-viewer__pic--progress" },
                          [
                            _c("el-progress", {
                              attrs: {
                                percentage: Number(item.percentage.toFixed(2)),
                                status: "success",
                                "hide-info": ""
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-upload",
        _vm._b(
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$slots.default || _vm.isUploadShow,
                expression: "$slots.default || isUploadShow"
              }
            ],
            ref: "upload",
            attrs: {
              "show-file-list": false,
              action: _vm.fullApiAction || _vm.action,
              data: _vm.isUseObs || _vm.useObsData ? _vm.obsUploadData : {},
              multiple: _vm.max !== _vm.PICTURE_NUM,
              limit: _vm.max,
              type: _vm.isUseObs ? "drag" : "select",
              "file-list": _vm.defaultList,
              accept: _vm.ACCEPT_MAP[_vm.uploadType] || "",
              "before-upload": _vm.handleBeforeUpload,
              "on-success": _vm.handleSuccess,
              "on-exceed": _vm.handleExceed,
              "on-error": _vm.handleError,
              "with-credentials":
                !["image", "video"].includes(_vm.uploadType) &&
                _vm.action.indexOf("yishou-img") === -1 &&
                !_vm.actionApi
            }
          },
          "el-upload",
          _vm.$attrs,
          false
        ),
        [
          !_vm.$slots.default
            ? _c("div", { staticClass: "upload-viewer__placeholder" }, [
                _c("i", {
                  class: _vm.iconMap[_vm.uploadType] || "el-icon-camera-solid",
                  staticStyle: { "font-size": "26px" }
                }),
                _vm._v(" "),
                _vm.max
                  ? _c(
                      "span",
                      { staticClass: "upload-viewer__placeholder--text" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.defaultList.length) +
                            "/" +
                            _vm._s(_vm.max) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _vm.isShowModalVideoPlay
        ? _c(
            "div",
            {
              staticClass: "video-modal",
              on: {
                click: function($event) {
                  _vm.isShowModalVideoPlay = false
                }
              }
            },
            [
              _c("video", {
                staticStyle: { height: "70vh" },
                attrs: { src: _vm.videoSrc, controls: "" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "video-modal__text",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleCopy(_vm.videoSrc)
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(
                      "若视频无法播放，可直接点击复制下方视频地址在其他浏览器或者手机上打开"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("视频地址：" + _vm._s(_vm.videoSrc))])
                ]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dd4363a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd4363a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YsComponents/YsUpload.vue
// module id = null
// module chunks = 